export default __webpack_public_path__ + "static/media/iconsprite.bf29d1c5.svg";